import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/Cart/Handlers/SaveOrder";
import { CustomState } from "@waytek/Store/Reducers";

replaceInChain(chain, PopulateApiParameter, props => {
    const state = props.getState() as CustomState;
    const cartState = getCurrentCartState(props.getState());

    if (!cartState.value) {
        throw new Error("There was no current cart and we are trying to save the current cart.");
    }

    props.apiParameter = {
        cart: {
            ...cartState.value,
            status: "Saved",
            // Verndale Customization
            properties: {
                savedCartName: state.savedOrder.savedCartName,
            },
        },
    };

    props.dispatch({
        type: "Custom/SavedOrderState/Reset",
        isModalOpen: false,
        savedCartName: "",
    } as any);
});
